export interface AddressDetail {
  name: string;
  addressLine1: string;
  suburb: string;
  postCode: string;
  state: string;
  country: string;
  isEmpty: boolean;
}

export enum AddressType {
  any,
  address,
  establishment,
  geocode
}
